import { Component, Input, OnInit, ChangeDetectionStrategy, SimpleChanges } from '@angular/core';
import { IForm } from 'src/app/models';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'medpt-field-builder',
    templateUrl: './field-builder.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FieldBuilderComponent implements OnInit {
  @Input() field: any;
  @Input() form: any;
  @Input() formInfo!: IForm;
  @Input() submitted: any;
  cdnEndPoint: string = environment.cdnEndPoint;
  get isValid() {
    //(this.form.controls[this.field.uniquename].valid ||
    let validForm = (this.form.controls[this.field.uniquename].touched || this.submitted) && this.form.controls[this.field.uniquename].errors?.['required'];
    console.log('isValid', !validForm);
    return !validForm;
  };

  get isDirty() {
    let isDirtyForm = this.form.controls[this.field.uniquename].dirty;
    console.log('isDirty', isDirtyForm);
    return isDirtyForm;
  };


  constructor() { }

  ngOnInit() {
    //console.log(this.formInfo);
  }

  get isCustomDropdown() {
    return this.field.MergeFieldName == 'SiteUsers'
      || this.field.MergeFieldName == 'SitePIs'
      || this.field.MergeFieldName == 'Country'
      || this.field.MergeFieldName == 'SiteNameDropDown';
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['submitted'] != undefined) {
      this.submitted = changes['submitted'].currentValue;
    } 
  }

}
